import axios from 'axios';

export async function getConversations(params = {}) {
  const response = await axios.get('/admin/chat/conversations', { params });
  return response.data;
}

export async function getConversation(id) {
  const response = await axios.get(`/admin/chat/conversations/${id}`);
  return response.data;
}

export async function getUsageSummary() {
  const response = await axios.get('/admin/chat/usage/summary');
  return response.data;
}

export async function getTokenLimits() {
  const response = await axios.get('/admin/chat/token-limits');
  return response.data;
}

export async function setTokenLimit(data) {
  const response = await axios.post('/admin/chat/token-limits', data);
  return response.data;
}

export async function deleteTokenLimit(id) {
  const response = await axios.delete(`/admin/chat/token-limits/${id}`);
  return response.data;
}
